import { Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { Empty, Image, Result, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { SmileOutlined } from "@ant-design/icons";
import loadingIcon from "../../assets/images/loading.gif";
import "./firstpage.css";

const FirstPage = () => {
  const [projects, setProjects] = useState([]);
  const [profile, setProfile] = useState(null);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [showEmpty, setShowEmpty] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const token = localStorage.getItem("access_token");
  const storedOrganisationName = localStorage.getItem("organisation_name"); // Retrieve organisation_name from localStorage
  const role = localStorage.getItem("role");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(
          " https://eutracker.rdiup.com/v1/user/getProfile/",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Assuming you store the token in localStorage
            },
          }
        );
        setProfile(response.data.user);
        console.log("partne", response.data.user.partner);
        console.log("profile", response.data.user);
        localStorage.setItem("partner", response.data.user.partner);
        localStorage.setItem("is_admin", response.data.user.is_admin);
        localStorage.setItem("user_id", response.data.user.pic_number);
      } catch (err) {
        console.log("Failed to fetch profile", err);
      }
    };

    fetchProfile();
  }, []);

  // Fetch projects data on component mount
  /* useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(
          " https://eutracker.rdiup.com/v1/projects/"
        );
        const data = response.data;
        const storedOrganisationName =
          localStorage.getItem("organisation_name")?.toLowerCase() || "";

        const filteredProjects = data.filter((project) => {
          const isCoordinator =
            project.coordinator_details &&
            (Array.isArray(project.coordinator_details)
              ? project.coordinator_details.some(
                  (detail) =>
                    detail.name.toLowerCase() === storedOrganisationName
                )
              : project.coordinator_details.name.toLowerCase() ===
                storedOrganisationName);

          const isMember =
            Array.isArray(project.members_details) &&
            project.members_details.some(
              (detail) => detail.name.toLowerCase() === storedOrganisationName
            );

          const isModerator =
            project.moderator_details &&
            (Array.isArray(project.moderator_details)
              ? project.moderator_details.some(
                  (detail) =>
                    detail.name.toLowerCase() === storedOrganisationName
                )
              : project.moderator_details.name.toLowerCase() ===
                storedOrganisationName);

          return isCoordinator || isMember || isModerator;
        });

        // Update state with filtered projects or all projects if the user is an admin
        if (profile && profile.is_admin === true) {
          setProjects(data);
          if (data.length > 0) {
            setProjectAutomatically(data[0]);
          }
        } else {
          setProjects(filteredProjects);
          if (filteredProjects.length > 0) {
            setProjectAutomatically(filteredProjects[0]);
          }
        }
      } catch (error) {
        console.error(
          "Error fetching projects:",
          error.response ? error.response.data : error.message
        );
      }
    };

    fetchProjects();
  }, [profile]); */

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(
          " https://eutracker.rdiup.com/v1/projects/"
        );
        const data = response.data;
        console.log("init data", data);

        const storedOrganisationId = parseInt(
          localStorage.getItem("organisation_name"),
          10
        );
        console.log("Stored organisation name:", storedOrganisationId);

        const filteredProjects = data.filter((project) => {
          const isCoordinator = project.coordinator === storedOrganisationId;
          const isMember =
            Array.isArray(project.members) &&
            project.members.includes(storedOrganisationId);
          const isModerator = project.moderator === storedOrganisationId;

          console.log(
            `Project: ${project.name}, Coordinator: ${isCoordinator}, Member: ${isMember}, Moderator: ${isModerator}`
          );

          // return isCoordinator || isMember || isModerator;

          // const isCoordinator =
          //   project.coordinator_details &&
          //   (Array.isArray(project.coordinator_details)
          //     ? project.coordinator_details.some(
          //         (detail) =>
          //           detail.name.toLowerCase() === storedOrganisationId
          //       )
          //     : project.coordinator_details.name.toLowerCase() ===
          //       storedOrganisationId);

          // const isMember =
          //   Array.isArray(project.members_details) &&
          //   project.members_details.some(
          //     (detail) => detail.name.toLowerCase() === storedOrganisationId
          //   );

          // const isModerator =
          //   project.moderator_details &&
          //   (Array.isArray(project.moderator_details)
          //     ? project.moderator_details.some(
          //         (detail) =>
          //           detail.name.toLowerCase() === storedOrganisationId
          //       )
          //     : project.moderator_details.name.toLowerCase() ===
          //       storedOrganisationId);

          console.log(
            `Project: ${project.name}, Coordinator: ${isCoordinator}, Member: ${isMember}, Moderator: ${isModerator}`
          );

          return isCoordinator || isMember || isModerator;
        });

        // Update state with filtered projects or all projects if the user is an admin

        if (profile && profile.is_admin === true) {
          setProjects(data);
          if (data.length > 0) {
            setProjectAutomatically(data[0]);
          }
        }
        if (profile && profile.is_admin === false) {
          console.log("filtered projects", filteredProjects);

          setProjects(filteredProjects);
          if (filteredProjects.length > 0) {
            setProjectAutomatically(filteredProjects[0]);
          }
        }
      } catch (error) {
        console.error(
          "Error fetching projects:",
          error.response ? error.response.data : error.message
        );
      }
    };

    fetchProjects();
  }, [profile]);

  let userRole = "none";

  // Function to set the first project automatically
  /* const setProjectAutomatically = (project) => {
    const storedOrganisationName = localStorage
      .getItem("organisation_name")
      ?.toLowerCase();

      
    if (project.coordinator_details) {
      const coordinatorNames = Array.isArray(project.coordinator_details)
        ? project.coordinator_details.map((detail) => detail.name.toLowerCase())
        : [project.coordinator_details.name.toLowerCase()];

      if (coordinatorNames.includes(storedOrganisationName)) {
        userRole = "coordinator";
      }
    }

    if (project.members_details) {
      const memberNames = project.members_details.map((detail) =>
        detail.name.toLowerCase()
      );

      if (memberNames.includes(storedOrganisationName)) {
        userRole = "member";
      }
    }

    if (project.moderator_details) {
      const moderatorNames = Array.isArray(project.moderator_details)
        ? project.moderator_details.map((detail) => detail.name.toLowerCase())
        : [project.moderator_details.name.toLowerCase()];

      if (moderatorNames.includes(storedOrganisationName)) {
        userRole = "moderator";
      }
    }

    if (project.moderator_details && project.coordinator_details) {
      const moderatorNames = Array.isArray(project.moderator_details)
        ? project.moderator_details.map((detail) => detail.name.toLowerCase())
        : [project.moderator_details.name.toLowerCase()];

      const coordinatorNames = Array.isArray(project.coordinator_details)
        ? project.coordinator_details.map((detail) => detail.name.toLowerCase())
        : [project.coordinator_details.name.toLowerCase()];

      if (
        moderatorNames.includes(storedOrganisationName) &&
        coordinatorNames.includes(storedOrganisationName)
      ) {
        userRole = "coordinator";
      }
    }

    localStorage.setItem("project_id", project.id);
    localStorage.setItem("project_name", project.name);
    localStorage.setItem("logo", project.imageURL);
    localStorage.setItem("project_color", project.color);

    localStorage.setItem("role", userRole);
    setSelectedProjectId(project.id);

    window.location.href = "/";
  };
 */
  const setProjectAutomatically = (project) => {
    const storedOrganisationId = parseInt(
      localStorage.getItem("organisation_name"),
      10
    );

    if (project.coordinator_details) {
      const coordinatorIds = Array.isArray(project.coordinator_details)
        ? project.coordinator_details.map((detail) => detail.id)
        : [project.coordinator_details.id];

      if (coordinatorIds.includes(storedOrganisationId)) {
        userRole = "coordinator";
      }
    }

    if (project.members_details) {
      const memberIds = project.members_details.map((detail) => detail.id);

      if (memberIds.includes(storedOrganisationId)) {
        userRole = "member";
      }
    }

    if (project.moderator_details) {
      const moderatorIds = Array.isArray(project.moderator_details)
        ? project.moderator_details.map((detail) => detail.id)
        : [project.moderator_details.id];

      if (moderatorIds.includes(storedOrganisationId)) {
        userRole = "moderator";
      }
    }

    if (project.moderator_details && project.coordinator_details) {
      const moderatorIds = Array.isArray(project.moderator_details)
        ? project.moderator_details.map((detail) => detail.id)
        : [project.moderator_details.id];

      const coordinatorIds = Array.isArray(project.coordinator_details)
        ? project.coordinator_details.map((detail) => detail.id)
        : [project.coordinator_details.id];

      if (
        moderatorIds.includes(storedOrganisationId) &&
        coordinatorIds.includes(storedOrganisationId)
      ) {
        userRole = "coordinator";
      }
    }

    localStorage.setItem("project_id", project.id);
    localStorage.setItem("project_name", project.name);
    localStorage.setItem("logo", project.imageURL);
    localStorage.setItem("project_color", project.color);
    localStorage.setItem("role", userRole);
    setSelectedProjectId(project.id);

    // i have added this timeout de 3s for redirection
    setTimeout(() => {
      window.location.href = "/";
    }, 3000);
  };
  const logout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  // and this is to show loading status (UX Design)
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowEmpty(true);
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Result
            icon={<SmileOutlined style={{ color: "#085ca4" }} />}
            title="We're now processing your login information. Sit tight, and we'll have you inside the app shortly!"
            subTitle="Eutracker"
          />
          <Image
            style={{ width: "150px", height: "150px" }}
            src={loadingIcon}
            preview={false}
          />
        </div>
      ) : !selectedProjectId && showEmpty ? (
        <Empty
          image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
          imageStyle={{
            height: 300,
          }}
          description={
            <Typography variant="h5">
              Sorry !! You're not asscoiated with any projects yet.
            </Typography>
          }
        >
          <Button type="primary" onClick={logout}>
            Log out
          </Button>

          <Button type="primary" onClick={() => navigate("/contact")}>
            Contact us
          </Button>
        </Empty>
      ) : (
        <></>
      )}
    </div>
  );
};

export default FirstPage;
